import React from 'react'

import checkAdminAccess from 'admin/functions/checkAdminAccess'
import { AdminTypes, LoginType } from 'types'

/**
 * Wrapper component rendering content if login prop's access matches component access
 */
// TODO: Fix component type when React types allow returning array from stateless component
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20356
const AdminAccess: any = ({ access, login, children }: AdminAccessProps) => {
  if (
    access &&
    login &&
    'administratorType' in login &&
    checkAdminAccess(login.administratorType, access)
  ) {
    return children
  }
  return null
}

type AdminAccessProps = {
  access: AdminTypes
  login: LoginType
  children: React.ReactNode
}

export default AdminAccess
